import React, { useState, Dispatch, SetStateAction } from "react";
import { DragUpdate } from "react-beautiful-dnd";
import api from "../../api/api";
import { useStore } from "../../store/store";
import { useQueryClient } from "react-query";
import { deleteUnit } from "../../api/SidebarApi";
import { UnitObj } from "../../util/quoteCartStorage";
import { reorder } from "./DragDropList";

function useDnDSelector(
  quoteId: string,
  units: UnitObj[],
  setUnits: Dispatch<SetStateAction<UnitObj[]>>,
  status: string,
  resetAllValues: () => void
) {
  const queryClient = useQueryClient();

  const isEdit = useStore((state) => state.isEdit);

  const [loadingDel, setLoadingDel] = useState(false);

  const [errorDel, setErrorDel] = useState(false);

  const [checkedIds, setCheckedIds] = useState<string[]>([]);

  const [showChecks, setShowChecks] = useState(false);

  const [hoverId, setHoverId] = useState("");

  const handleCloseModal = () => {
    setHoverId("");
    setErrorDel(false);
    setCheckedIds([]);
  };

  const onDragEnd = async (result: DragUpdate) => {
    if (
      !result.destination ||
      !units.length ||
      result.source.index === result.destination.index
    )
      return;

    if (status !== "Quote") {
      alert("Can't rearrange units on Orders");
      return;
    }

    const newOrder = reorder(
      units,
      result.source.index,
      result.destination.index,
    );

    setUnits(newOrder);

    await api.post("/api/reorderUnits", {
      quoteId,
      unitOrder: newOrder,
    });
  };

  const handleCheck = (
    event: React.ChangeEvent<HTMLInputElement>,
    id: string,
  ) => {
    const { checked } = event.target;
    if (checked) {
      if (!checkedIds.includes(id)) {
        setCheckedIds((prev) => [...prev, id]);
        setShowChecks(true);
      }
    } else {
      const cids = [...checkedIds];
      const filtCids = cids.filter((item) => item !== id);
      setCheckedIds(filtCids);
      if (!filtCids.length) {
        setShowChecks(false);
      }
    }
  };

  const removeUnits = async () => {
    setLoadingDel(true);
    const editId = JSON.parse(
      sessionStorage.getItem("unitId") || JSON.stringify(""),
    );

    if (checkedIds.length && checkedIds.includes(editId)) {
      resetAllValues();
    }

    const res = await deleteUnit(quoteId, checkedIds, units);

    if (res.data.quote) {
      setLoadingDel(false);
      setErrorDel(false);
      return queryClient.invalidateQueries("QuoteCart");
    }

    setErrorDel(true);
    setLoadingDel(false);
  };

  const mouseEnter = (unitId: string | undefined) => {
    setHoverId(unitId || "");
  };

  const mouseLeave = () => {
    if (!checkedIds.length) {
      setHoverId("");
    }
  };

  return {
    mouseEnter,
    mouseLeave,
    removeUnits,
    handleCheck,
    onDragEnd,
    handleCloseModal,
    hoverId,
    showChecks,
    checkedIds,
    errorDel,
    loadingDel,
    isEdit,
  };
}

export default useDnDSelector;
